import { computed, inject, Injectable, signal } from '@angular/core';
import { ApiGatewayService } from './api-gateway.service';
import { UserProfile } from './interfaces';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { catchError, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private gateway: ApiGatewayService = inject(ApiGatewayService);
  private router: Router = inject(Router);
  private authService: AuthService = inject(AuthService);
  private userprofile = signal<UserProfile | null>(null);
  readonly userprofile$ = toObservable(this.userprofile);

  readonly identity = computed(() => {
    const profile = this.userprofile();
    console.log('Profile Service', profile);
    if (profile) {
      return {
        username: profile.username,
        roles: [profile.group],
        firstName: profile?.first_name,
        lastName: profile?.surname,
        email: profile?.email,
      };
    }
    return null;
  });

  get username(): string {
    return this.userprofile()?.username || '';
  }

  get group(): string {
    return this.userprofile()?.group || '';
  }

  loadProfile() {
    return this.gateway.get<UserProfile>('/me').pipe(
      tap((profile) => this.userprofile.set(profile)),
      catchError((e) => {
        console.log(e);
        if (e.status == 401) {
          this.authService.logout().subscribe((_) => {
            this.clearProfile();
            this.router.navigate(['/login']);
          });
        }

        return throwError(() => e);
      }),
    );
  }

  logout() {
    this.authService.logout().subscribe({
      next: () => {
        this.clearProfile();
        this.router.navigate(['/login']);
      },
    });
  }

  clearProfile() {
    this.userprofile.set(null);
  }
}
